import { DOCUMENT } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input, inject, Injectable, Directive, Inject, HostListener } from '@angular/core';
import { checkTimeout } from '@js-dot/core';
import { afterAnimate$ } from '@js-dot/ui/animate';
import { setOverlayPosition } from '@js-dot/ux';
import * as i1 from '@ng-dot/core';
import { DotPoolComponent } from '@ng-dot/core';

/**
 * Element Overlay Tooltip
 */
class DotTipComponent {
  componentRef;
  set innerHTML(value) {
    this.node.innerHTML = value;
  }
  node;
  constructor(elementRef) {
    this.node = elementRef.nativeElement;
  }
  destroy() {
    afterAnimate$(this.node, '_leave').then(() => {
      this.componentRef.destroy();
    });
  }
  static ɵfac = function DotTipComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotTipComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotTipComponent,
    selectors: [["ng-component"]],
    hostAttrs: [1, "dot-tip", "_js"],
    inputs: {
      componentRef: "componentRef",
      innerHTML: "innerHTML"
    },
    decls: 0,
    vars: 0,
    template: function DotTipComponent_Template(rf, ctx) {},
    styles: [":root{--tip-back: var(--t, #000);--tip-text: var(--b, #fff);--tip-radius: 4px;--tip-enter-anis: .12s tip-enter;--tip-exit-anis: .24s tip-exit}.dot-tip{position:fixed;background-color:var(--tip-back);color:var(--tip-text);border-radius:var(--tip-radius);animation:var(--tip-enter-anis);font-size:.875rem;padding:8px 16px;z-index:9999;transform-origin:var(--tip_to-x) var(--tip_to-y)}.dot-tip:not(._js){display:none;position:absolute;top:100%;left:50%}.dot-tip:before{content:\"\";position:absolute}.dot-tip._leave{animation:var(--tip-exit-anis)}.dot-tip.dot-overlay_left{--tip_to-x: left}.dot-tip.dot-overlay_center{--tip_to-x: center}.dot-tip.dot-overlay_right{--tip_to-x: right}.dot-tip.dot-overlay_top{--tip_to-y: bottom;margin-top:-6px}.dot-tip.dot-overlay_top:before{bottom:-6px}.dot-tip.dot-overlay_top-left{border-bottom-left-radius:0}.dot-tip.dot-overlay_top-left:before{width:0;height:0;border:3px solid var(--tip-back);border-right-color:transparent;border-bottom-color:transparent;left:0}.dot-tip.dot-overlay_top-center:before{width:0;height:0;border-left:6px solid transparent;border-right:6px solid transparent;border-top:6px solid var(--tip-back);left:50%;transform:translate(-50%)}.dot-tip.dot-overlay_top-right{border-bottom-right-radius:0}.dot-tip.dot-overlay_top-right:before{width:0;height:0;border:3px solid var(--tip-back);border-bottom-color:transparent;border-left-color:transparent;right:0}.dot-tip.dot-overlay_bottom{--tip_to-y: top;margin-top:6px}.dot-tip.dot-overlay_bottom:before{top:-6px}.dot-tip.dot-overlay_bottom-left{border-top-left-radius:0}.dot-tip.dot-overlay_bottom-left:before{width:0;height:0;border:3px solid transparent;border-bottom-color:var(--tip-back);border-left-color:var(--tip-back);left:0}.dot-tip.dot-overlay_bottom-center:before{width:0;height:0;border-left:6px solid transparent;border-right:6px solid transparent;border-bottom:6px solid var(--tip-back);left:50%;transform:translate(-50%)}.dot-tip.dot-overlay_bottom-right{border-top-right-radius:0}.dot-tip.dot-overlay_bottom-right:before{width:0;height:0;border:3px solid transparent;border-right-color:var(--tip-back);border-bottom-color:var(--tip-back);right:0}*:has(>.dot-tip:not(._js)){position:relative}*:has(>.dot-tip:not(._js)):hover>.dot-tip{display:block}@keyframes tip-enter{0%{transform:scale(.8);opacity:0}}@keyframes tip-exit{to{transform:scale(.8);opacity:0}}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotTipComponent, [{
    type: Component,
    args: [{
      standalone: true,
      template: ``,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        class: 'dot-tip _js'
      },
      styles: [":root{--tip-back: var(--t, #000);--tip-text: var(--b, #fff);--tip-radius: 4px;--tip-enter-anis: .12s tip-enter;--tip-exit-anis: .24s tip-exit}.dot-tip{position:fixed;background-color:var(--tip-back);color:var(--tip-text);border-radius:var(--tip-radius);animation:var(--tip-enter-anis);font-size:.875rem;padding:8px 16px;z-index:9999;transform-origin:var(--tip_to-x) var(--tip_to-y)}.dot-tip:not(._js){display:none;position:absolute;top:100%;left:50%}.dot-tip:before{content:\"\";position:absolute}.dot-tip._leave{animation:var(--tip-exit-anis)}.dot-tip.dot-overlay_left{--tip_to-x: left}.dot-tip.dot-overlay_center{--tip_to-x: center}.dot-tip.dot-overlay_right{--tip_to-x: right}.dot-tip.dot-overlay_top{--tip_to-y: bottom;margin-top:-6px}.dot-tip.dot-overlay_top:before{bottom:-6px}.dot-tip.dot-overlay_top-left{border-bottom-left-radius:0}.dot-tip.dot-overlay_top-left:before{width:0;height:0;border:3px solid var(--tip-back);border-right-color:transparent;border-bottom-color:transparent;left:0}.dot-tip.dot-overlay_top-center:before{width:0;height:0;border-left:6px solid transparent;border-right:6px solid transparent;border-top:6px solid var(--tip-back);left:50%;transform:translate(-50%)}.dot-tip.dot-overlay_top-right{border-bottom-right-radius:0}.dot-tip.dot-overlay_top-right:before{width:0;height:0;border:3px solid var(--tip-back);border-bottom-color:transparent;border-left-color:transparent;right:0}.dot-tip.dot-overlay_bottom{--tip_to-y: top;margin-top:6px}.dot-tip.dot-overlay_bottom:before{top:-6px}.dot-tip.dot-overlay_bottom-left{border-top-left-radius:0}.dot-tip.dot-overlay_bottom-left:before{width:0;height:0;border:3px solid transparent;border-bottom-color:var(--tip-back);border-left-color:var(--tip-back);left:0}.dot-tip.dot-overlay_bottom-center:before{width:0;height:0;border-left:6px solid transparent;border-right:6px solid transparent;border-bottom:6px solid var(--tip-back);left:50%;transform:translate(-50%)}.dot-tip.dot-overlay_bottom-right{border-top-right-radius:0}.dot-tip.dot-overlay_bottom-right:before{width:0;height:0;border:3px solid transparent;border-right-color:var(--tip-back);border-bottom-color:var(--tip-back);right:0}*:has(>.dot-tip:not(._js)){position:relative}*:has(>.dot-tip:not(._js)):hover>.dot-tip{display:block}@keyframes tip-enter{0%{transform:scale(.8);opacity:0}}@keyframes tip-exit{to{transform:scale(.8);opacity:0}}\n"]
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    componentRef: [{
      type: Input
    }],
    innerHTML: [{
      type: Input
    }]
  });
})();
class DotTipService {
  _core;
  _component;
  _pool;
  _document = inject(DOCUMENT);
  constructor(_core, _component) {
    this._core = _core;
    this._component = _component;
    this._pool = this._component.pool(DotPoolComponent, DotTipComponent, {
      activeFullscreenElement: true
    });
  }
  append(innerHTML) {
    return this._pool.append({
      innerHTML
    });
  }
  static ɵfac = function DotTipService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotTipService)(i0.ɵɵinject(i1.DotCoreService), i0.ɵɵinject(i1.DotComponentService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DotTipService,
    factory: DotTipService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotTipService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.DotCoreService
  }, {
    type: i1.DotComponentService
  }], null);
})();
/**
 * Advisory information related to the element
 */
class DotTipDirective {
  _tip;
  set fromSelector(value) {
    this.tip = value;
  }
  set tip(value) {
    if (this._value !== value) {
      this._value = value;
      if (this._tipComponent) {
        this.hide();
        this.show();
      }
    }
  }
  delay = 0;
  _value;
  _tipComponent;
  _root;
  _body;
  _host;
  _display;
  _showTimer;
  constructor(_tip, ngDocument, elementRef) {
    this._tip = _tip;
    this._root = ngDocument.documentElement;
    this._body = ngDocument.body;
    this._host = elementRef.nativeElement;
  }
  ngOnDestroy() {
    this.hide();
  }
  show() {
    this._showTimer = checkTimeout(this._showTimer, this.#show.bind(this), this.delay);
  }
  #show() {
    if (!this._value) {
      return;
    }
    const {
      _host,
      _tipComponent
    } = this;
    if (!_tipComponent) {
      const {
        _value
      } = this;
      _host.ariaLabel = _value;
      this._tipComponent = this._tip.append(_value);
    }
    setOverlayPosition(this._root, _host, this._tipComponent.instance.node, ['t', 'b']);
  }
  hide() {
    checkTimeout(this._showTimer);
    if (!this._tip) {
      return;
    }
    const {
      _tipComponent
    } = this;
    if (_tipComponent) {
      _tipComponent.instance.destroy();
      this._tipComponent = null;
    }
  }
  onMouseEnter() {
    this.show();
  }
  onMouseLeave() {
    this.hide();
  }
  onFocus() {
    this.show();
  }
  onBlur() {
    this.hide();
  }
  static ɵfac = function DotTipDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotTipDirective)(i0.ɵɵdirectiveInject(DotTipService), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DotTipDirective,
    selectors: [["", "dotTip", ""]],
    hostBindings: function DotTipDirective_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("mouseenter", function DotTipDirective_mouseenter_HostBindingHandler() {
          return ctx.onMouseEnter();
        })("mouseleave", function DotTipDirective_mouseleave_HostBindingHandler() {
          return ctx.onMouseLeave();
        })("focus", function DotTipDirective_focus_HostBindingHandler() {
          return ctx.onFocus();
        })("blur", function DotTipDirective_blur_HostBindingHandler() {
          return ctx.onBlur();
        });
      }
    },
    inputs: {
      fromSelector: [0, "dotTip", "fromSelector"],
      tip: "tip",
      delay: "delay"
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotTipDirective, [{
    type: Directive,
    args: [{
      standalone: true,
      selector: '[dotTip]'
    }]
  }], () => [{
    type: DotTipService
  }, {
    type: Document,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }, {
    type: i0.ElementRef
  }], {
    fromSelector: [{
      type: Input,
      args: ['dotTip']
    }],
    tip: [{
      type: Input
    }],
    delay: [{
      type: Input
    }],
    onMouseEnter: [{
      type: HostListener,
      args: ['mouseenter']
    }],
    onMouseLeave: [{
      type: HostListener,
      args: ['mouseleave']
    }],
    onFocus: [{
      type: HostListener,
      args: ['focus']
    }],
    onBlur: [{
      type: HostListener,
      args: ['blur']
    }]
  });
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DotTipComponent, DotTipDirective, DotTipService };
